<template>
  <div class="loading-animation" :class="[loaderClass, { bordered: border, solid: solid }]">
    <div v-if="animation" class="loading-animation--animation" :style="animationStyle">
      <AnimationItem :animation="{ animationData: animation }" :key="'anim_paintbrush'" />
    </div>
    <div v-if="displayText" class="loading-animation--title">{{ displayText }} <span v-if="useCounter">{{ counter }}s</span></div>
    <div>
      <small>
        {{ $gettext('(Can take up to 30s)') }}
      </small>
    </div>
  </div>
</template>

<script>

import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'

export default {
  name: 'LoadingAnimation',
  components: {
    AnimationItem,
  },
  props: {
    border: {
      type: Boolean,
      default: false
    },
    displayText: {
      type: String,
      defailt: null
    },
    minHeight: {
      type: Boolean,
      default: false
    },
    animation: {
      type: Object,
      default: null
    },
    animationHeight: {
      type: Number,
      default: 150
    },
    useCounter: {
      type: Boolean,
      default: false
    },
    solid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      counter: 1,
      counterId: null,
    }
  },
  computed: {
    loaderClass () {
      return [
        (this.minHeight) ? 'loading-spinner--min-height' : '',
      ]
    },
    animationStyle () {
      let style = ''
      if (this.animationHeight) {
        style += 'height: ' + this.animationHeight + 'px'
      }
      return style
    }
  },
  mounted () {
    if (this.useCounter) {
      this.counterId = setInterval(this.updateCounter, 1000)
    }
  },
  beforeDestroy () {
    if (this.counterId) {
      clearInterval(this.counterId)
    }
  },
  methods: {
    updateCounter () {
      this.counter += 1
    }
  },
}
</script>

<style lang="scss" scoped>
  .loading-animation {
    transition: opacity 0.3s ease;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.8);
    z-index: 100;
    border-radius: inherit;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.bordered {
      border: 1px solid $colorBorderDash;
    }
    &.solid {
      background: rgba(255,255,255,1);
    }
    &--min-height {
      min-height: 360px;
    }
    &--animation {
      height: 150px;
    }
    &--title {
      // z-index: 2;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, 40px);
    }
    small {
      opacity: 0.7;
    }
  } 
</style>